var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"73694cdef09ae6afe2724e877a0e37c675c57fe5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hem-com@hem-design-studio"]={id:"73694cdef09ae6afe2724e877a0e37c675c57fe5"};
      